// @ts-nocheck
import React from 'react';
import { Box, TextField } from '@mui/material';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';

const EmailFormFieldPreview = ({
  element,
  answer,
  handleAnswerChange,
  shouldBeReadOnly,
}) => (
  <Box key={element?.id} m={1}>
    <FieldsInputTitle
      label={element?.label || element?.name}
      isRequired={element?.isRequired}
    />
    <Box mt={1.5}>
      <TextField
        name="Text"
        key={element?.id}
        value={answer}
        onChange={handleAnswerChange}
        variant="outlined"
        fullWidth
        placeholder="Answer"
        disabled={shouldBeReadOnly}
      />
    </Box>
  </Box>
);

export default EmailFormFieldPreview;
